// extracted by mini-css-extract-plugin
module.exports = {"toggleSwitchContainer":"styles_toggleSwitchContainer__x8Bk-","reactSwitch":"styles_reactSwitch__2wyak","switchText":"styles_switchText__1GLL8"};